module.exports = __webpack_public_path__ + "img/cpp.837de8a1.svg";